import styled from "styled-components";

export const GuardianForm = styled.form`
  gap: 30px;
  width: 100%;
  display: flex;
  padding: 30px 30px 20px;
  flex-direction: column;
`;

export const SearchBox = styled.div`
  gap: 8px;
  width: 100%;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;

  & > span {
    color: ${(props) => props.theme.colors.black50};
    font-size: 1.1rem;
  }
`;
